export default "__VITE_ASSET__976385b4__"